import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverrideComponent } from './override.component';
import { IconTitleModule } from '../components/icon-title/icon-title.module';
import { RadioGroupModule } from '../../radio-group/radio-group.module';
import { AtomsModule } from '@library/ui/atoms/atoms.module';
import { ActivableTextModule } from '../../activables/activable-text/activable-text.module';

@NgModule({
  declarations: [
    OverrideComponent
  ],
  exports: [
    OverrideComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconTitleModule,
    RadioGroupModule,
    AtomsModule,
    ActivableTextModule
  ]
})
export class OverrideModule { }
